/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Cta_TitleInputs */

const en_endpoint_cta_title = /** @type {(inputs: Endpoint_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That came back from a live API call.`)
};

const zh_hans1_endpoint_cta_title = /** @type {(inputs: Endpoint_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是一次真实 API 调用返回的结果。`)
};

const pt_br2_endpoint_cta_title = /** @type {(inputs: Endpoint_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso veio de uma chamada real à API.`)
};

const es_endpoint_cta_title = /** @type {(inputs: Endpoint_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eso vino de una llamada real a la API.`)
};

const fr_endpoint_cta_title = /** @type {(inputs: Endpoint_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette réponse vient d’un vrai appel d’API.`)
};

const de_endpoint_cta_title = /** @type {(inputs: Endpoint_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das kam aus einem Live-API-Aufruf.`)
};

const ru_endpoint_cta_title = /** @type {(inputs: Endpoint_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это пришло из живого вызова API.`)
};

const it_endpoint_cta_title = /** @type {(inputs: Endpoint_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo risultato viene da una chiamata API reale.`)
};

/**
* | output |
* | --- |
* | "That came back from a live API call." |
*
* @param {Endpoint_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cta_title = /** @type {((inputs?: Endpoint_Cta_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cta_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cta_title(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cta_title(inputs)
	if (locale === "es") return es_endpoint_cta_title(inputs)
	if (locale === "fr") return fr_endpoint_cta_title(inputs)
	if (locale === "de") return de_endpoint_cta_title(inputs)
	if (locale === "ru") return ru_endpoint_cta_title(inputs)
	if (locale === "it") return it_endpoint_cta_title(inputs)
	return en_endpoint_cta_title(inputs)
});